import { styled, Button } from '@mui/material';
import { rem, Bold } from '@core-web/typography';

const TextStyle = {
  fontSize: rem(12),
  fontWeight: Bold._600,
  lineHeight: rem(18),
  letterSpacing: '-0.2px',
};

export const ModalButton = styled(Button)(({ theme: { palette } }) => ({
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  textTransform: 'capitalize',
  gap: rem(10),
  padding: `${rem(5)} ${rem(10)}`,
  ...TextStyle,
  height: rem(40),
  borderRadius: rem(6),
  '&:hover': {
    boxShadow: palette.boxShadow.buttonShadow,
  },
  '&.success': {
    color: palette.colors.white,
    backgroundColor: palette.colors.green_600,
  },
  '&.danger': {
    color: palette.colors.white,
    backgroundColor: palette.error.main,
  },
  '&.primary': {
    color: palette.colors.white,
    backgroundColor: palette.colors.blue_700,
  },
  '&.outline-light': {
    color: palette.colors.grey_500,
    backgroundColor: palette.colors.white,
    border: `1px solid ${palette.colors.grey_500}`,
  },
}));
